import React, { useState } from "react";
import { Paper } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { Image, PopUp, Player } from "./../";

function Video({
	thumbnail,
	url,
	cloudflare,
	orientation = "landscape",
	size = "md",
	thumbnailSize = "full",
	isSidebar = false,
}) {
	const [elevation, setElevation] = useState(1);
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const img_src = thumbnail
		? thumbnail.src
			? thumbnail.src
			: thumbnail.url
		: null;

	let link_attrs = {
		href: "#",
	};
	if (url) {
		link_attrs = {
			href: url,
			target: "_blank",
			rel: "noreferrer",
		};
	}

	return (
		<>
			<PopUp open={open} handleClose={handleClose}>
				<Player url={url} poster={img_src} cloudflare={cloudflare} />
			</PopUp>
			<Paper
				className="video-block"
				component="a"
				{...link_attrs}
				elevation={elevation}
				onFocus={(e) => setElevation(10)}
				onBlur={(e) => setElevation(10)}
				onMouseEnter={(e) => setElevation(10)}
				onMouseLeave={(e) => setElevation(1)}
				onClick={(e) => {
					e.preventDefault();
					handleOpen();
				}}
				sx={(theme) => ({
					position: "relative",
					display: "block",
					textDecoration: "none",
					"&:focus, &:hover, &:active": {
						"& .MuiSvgIcon-root": {
							transform: "scale(1.1)",
						},
					},
					"& figure": {
						margin: 0,
						"& .MuiPaper-root": {
							backgroundColor: theme.palette.grey["300"],
						},
					},
					"&::after": {
						display: "none !important",
					},
				})}
			>
				<PlayCircleOutlineIcon
					className={`size-${size}`}
					sx={(theme) => ({
						height: "100%",
						position: "absolute",
						left: "50%",
						top: 0,
						fill: "#fff",
						width: "100px",
						marginLeft: "-50px",
						"&.size-lg": {
							width: "150px",
							marginLeft: "-75px",
						},
						[theme.breakpoints.down("lg")]: {
							width: "80px !important",
							marginLeft: "-40px !important",
						},
						[theme.breakpoints.down("sm")]: {
							width: "60px !important",
							marginLeft: "-30px !important",
						},
					})}
				/>
				<Image
					src={img_src}
					orientation={orientation}
					size={thumbnailSize}
					video
					isSidebar={isSidebar}
				></Image>
			</Paper>
		</>
	);
}

export default Video;
